module.exports = __webpack_public_path__ + "img/pop_gaotong@2x.d8ba6334.png";